<template>
  <v-dialog v-model="esActiva" persistent max-width="500px">
    <v-card>
      <v-card-title>PIN Distribuidor</v-card-title> 
      <v-card-text>
        <v-text-field
          v-model="valor_contrasenia"
          :type="mostrar_contrasenia ? 'text' : 'password'"
          :append-icon="mostrar_contrasenia ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[v => !!v || 'El PIN es obligatorio']"
          @click:append="mostrar_contrasenia = !mostrar_contrasenia"
          placeholder="Introduzca PIN"
          solo
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="cerrar_modal">
            <v-icon left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="primary" text @click="match_contrasenia" :disabled="!valor_contrasenia">
            <v-icon left>mdi-check</v-icon>
            Validar
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>               
</template>

<script>

export default {
  props:{
    esActiva: Boolean,
    contrasenia: String    
  },
  data: () => ({
    mostrar_contrasenia: false,
    valor_contrasenia: null
  }),
  methods: {
    cerrar_modal(){
      this.$emit('respuesta_modal_contrasenia', false );
    },
    match_contrasenia(){     
      if(this.valor_contrasenia === this.contrasenia){
        this.$emit('respuesta_modal_contrasenia', true );
      }else{
        this.$root.$emit("snackbar", { mostrar: true, color: "error", texto: "Las contraseña es incorrecta, intente de nuevo" });
      }      
    }
  }
}
</script>